import store from "@/store";

const ifNotAuthenticated = (to, from, next) => {
  console.log("ifNotAuthenticated", store.getters);
  if (!store.getters.get_access_token) {
    next();
    return;
  }
  next({
    name: "PageEntities",
    params: {
      locale: to.params.locale,
      client_name: to.params.client_name,
    },
  });
};

const ifAuthenticated = (to, from, next) => {
  if (store.getters.get_access_token) {
    next();
    return;
  }
  next({
    name: "PageLogin",
    params: {
      locale: to.params.locale,
      client_name: to.params.client_name,
    },
  });
};
const beforeRegistrationStep = (to, _, next) => {
  if (!store.getters.isTestMode && !store.getters.getUserStatus) {
    next({ name: "PageContactInformation", params: to.params });
  }
  next();
};

export default [
  {
    path: "/:client_name",
    component: {
      template: "<router-view></router-view>",
    },
    children: [
      {
        path: "login",
        name: "PageLogin",
        meta: {
          title: "Login",
          layout: "AuthLayout",
        },
        beforeEnter: ifNotAuthenticated,
        component: () => import(`@/views/Auth/Login.vue`),
      },
      {
        path: "audit",
        name: "PageAudit",
        meta: {
          title: "Audit",
          layout: "DefaultLayout",
        },
        beforeEnter: ifAuthenticated,
        component: () => import(`@/views/Managment/PageAudit.vue`),
      },
      {
        path: "entities",
        name: "PageEntities",
        meta: {
          title: "Entities",
          layout: "DefaultLayout",
        },
        beforeEnter: ifAuthenticated,
        component: () => import(`@/views/Managment/Entities/PageEntities.vue`),
        children: [
          {
            path: ":entityID",
            name: "PageActiveEntity",
            meta: {
              title: "Entity",
              layout: "DefaultLayout",
            },
            // beforeEnter: ifAuthenticated,
            beforeEnter: (to, from, next) => {
              if (store.getters.get_access_token) {
                if (to.name === "PageActiveEntity") {
                  next(to.path + "/info");
                  return;
                }
                next();
                return;
              } else {
                next({
                  name: "PageLogin",
                  params: {
                    locale: to.params.locale,
                    client_name: to.params.client_name,
                  },
                });
              }
            },
            component: () =>
              import(`@/views/Managment/Entities/PageActiveEntity.vue`),
            children: [
              {
                path: "info",
                name: "PageActiveEntityInfo",
                meta: {
                  title: "EntityInfo",
                  layout: "DefaultLayout",
                },
                beforeEnter: ifAuthenticated,
                component: () =>
                  import(`@/views/Managment/Entities/PageActiveEntityInfo.vue`),
              },
              {
                path: "profiles",
                name: "PageActiveEntityProfiles",
                meta: {
                  title: "EntityProfiles",
                  layout: "DefaultLayout",
                },
                beforeEnter: ifAuthenticated,
                component: () =>
                  import(
                    `@/views/Managment/Entities/PageActiveEntityProfiles.vue`
                  ),
              },
              {
                path: "emails",
                name: "PageActiveEntityEmails",
                meta: {
                  title: "EntityEmails",
                  layout: "DefaultLayout",
                },
                beforeEnter: ifAuthenticated,
                component: () =>
                  import(
                    `@/views/Managment/Entities/PageActiveEntityEmails.vue`
                  ),
              },
            ],
          },
        ],
      },
      // subscribe
      {
        path: ":context_key/subscribe",
        component: {
          template: "<router-view></router-view>",
        },
        children: [
          {
            path: "contact-informations",
            name: "PageContactInformation",
            meta: {
              layout: "LayoutSubscribe",
              step: 1,
            },
            component: () =>
              import(`@/views/Subscribe/1-contact-informations.vue`),
          },
          {
            path: "security-code",
            name: "PageSecurityCode",
            meta: {
              layout: "LayoutSubscribe",
              step: 2,
            },
            props: true,
            component: () => import(`@/views/Subscribe/2-security-code.vue`),
          },
          {
            path: "intervenant-details",
            name: "PageSelfUserDetails",
            meta: {
              layout: "LayoutSubscribe",
              step: 3,
            },
            beforeEnter: beforeRegistrationStep,
            component: () => import(`@/views/Subscribe/3-user-details.vue`),
          },
          {
            path: "user-not-found",
            name: "PageSelfUserNotFound",
            meta: {
              layout: "LayoutSubscribe",
              step: 3,
            },
            beforeEnter: beforeRegistrationStep,
            component: () => import(`@/views/Subscribe/3-user-not-found.vue`),
          },
          {
            path: "several-users-found",
            name: "PageSelfSeveralUsersFound",
            meta: {
              layout: "LayoutSubscribe",
              step: 3,
            },
            beforeEnter: beforeRegistrationStep,
            component: () =>
              import(`@/views/Subscribe/3-user-several-found.vue`),
          },
          {
            path: "search-establishment",
            name: "PageSearchEstablishment",
            meta: {
              layout: "LayoutSubscribe",
              step: 4,
            },
            beforeEnter: beforeRegistrationStep,
            component: () =>
              import(`@/views/Subscribe/4-search-establishment.vue`),
          },
          {
            path: "establishment-result-list",
            name: "PageEstablishmentResultList",
            meta: {
              layout: "LayoutSubscribe",
              step: "5",
            },
            beforeEnter: beforeRegistrationStep,
            component: () =>
              import(`@/views/Subscribe/5-establishment-result-list.vue`),
          },
          {
            path: "establishment-not-found",
            name: "PageEstablishmentNotFound",
            meta: {
              layout: "LayoutSubscribe",
              step: "5",
            },
            beforeEnter: beforeRegistrationStep,
            component: () =>
              import(`@/views/Subscribe/5-establishment-not-found.vue`),
          },
          {
            path: "select-service",
            name: "PageSelectService",
            meta: {
              layout: "LayoutSubscribe",
              step: "6",
            },
            beforeEnter: beforeRegistrationStep,
            component: () => import(`@/views/Subscribe/6-select-service.vue`),
          },
          {
            path: "initialize-account",
            name: "PageInitializeAccount",
            meta: {
              layout: "LayoutSubscribe",
              step: 7,
            },
            beforeEnter: beforeRegistrationStep,
            component: () =>
              import(`@/views/Subscribe/7-initialize-account.vue`),
          },
          {
            path: "account-information",
            name: "PageAccountInformations",
            meta: {
              layout: "LayoutSubscribe",
              step: 7.1,
            },
            beforeEnter: beforeRegistrationStep,
            component: () =>
              import(`@/views/Subscribe/7-account-informations.vue`),
          },
          {
            path: "confirm-subscribe",
            name: "PageConfirmSubscribe",
            meta: {
              layout: "LayoutSubscribe",
              step: 8,
            },
            beforeEnter: beforeRegistrationStep,
            component: () =>
              import(`@/views/Subscribe/8-confirm-subscribe.vue`),
          },
          {
            path: "pharmacist-informations",
            name: "PagePharmacistInformations",
            meta: {
              layout: "LayoutSubscribe",
              step: 8.1,
              title: "registrStepsTitle.step8_1",
            },
            beforeEnter: beforeRegistrationStep,
            component: () =>
              import(`@/views/Subscribe/8-pharmacist-informations.vue`),
          },
          {
            path: "end-subscription",
            name: "PageEndSubscription",
            meta: {
              layout: "LayoutSubscribe",
              step: 9,
            },
            component: () => import(`@/views/Subscribe/9-end-subscription.vue`),
          },
        ],
      },
      {
        path: "",
        redirect: (to) => {
          return { name: "PageError", params: to.params };
        },
      },
    ],
  },
  {
    path: "/error-page",
    name: "PageError",
    meta: {
      title: "PageError",
      layout: "LayoutError",
      error: true,
    },
    params: {
      message: "errorHappens",
    },
    component: () => import(`@/views/PageError.vue`),
  },
  {
    path: "/:catchAll(.*)", // Unrecognized path automatically matches 404
    redirect: (to) => {
      return { name: "PageError", params: to.params };
    },
  },
];
